import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconMesh({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<g fill="#CD0400">
					<path d="M12.717 12.618c.001.41-.497.615-.789.326a.459.459 0 0 1 .327-.784c.255 0 .462.205.462.458m-2.22 0c0 .706.428 1.342 1.084 1.612s1.414.122 1.917-.377.653-1.25.381-1.9a1.76 1.76 0 0 0-1.624-1.078c-.97.002-1.756.78-1.758 1.743M6.855 5.39c0 .448.27.851.687 1.023s.897.077 1.216-.24A1.1 1.1 0 0 0 9 4.968a1.115 1.115 0 0 0-1.03-.684c-.616.001-1.114.496-1.115 1.106" />
					<path
						fillRule="nonzero"
						d="M7.646 4.92a.54.54 0 0 1 .733.19l3.525 5.945a.53.53 0 0 1-.19.728.54.54 0 0 1-.734-.189L7.456 5.648a.53.53 0 0 1 .19-.727"
					/>
					<path
						fillRule="nonzero"
						d="M7.777 5.513a.54.54 0 0 1 .204.729l-3.387 6.025a.53.53 0 0 1-.725.2.54.54 0 0 1-.204-.73l3.387-6.025a.53.53 0 0 1 .725-.2M7.777 19.908a.54.54 0 0 0 .204-.73l-3.387-6.025a.53.53 0 0 0-.725-.2.54.54 0 0 0-.204.73l3.387 6.025a.53.53 0 0 0 .725.2M16.725 5.513a.54.54 0 0 0-.204.729l3.387 6.025a.53.53 0 0 0 .725.2.54.54 0 0 0 .204-.73L17.45 5.712a.53.53 0 0 0-.725-.2M16.725 19.695a.54.54 0 0 1-.204-.73l3.387-6.025a.53.53 0 0 1 .725-.199.54.54 0 0 1 .204.73l-3.387 6.025a.53.53 0 0 1-.725.199"
					/>
					<path
						fillRule="nonzero"
						d="M3.335 12.65a.54.54 0 0 1 .53-.54l6.911-.08a.53.53 0 0 1 .535.528.54.54 0 0 1-.53.54l-6.911.08a.53.53 0 0 1-.535-.528M8.048 5.421a.54.54 0 0 1 .53-.54l6.912-.08a.53.53 0 0 1 .535.528.54.54 0 0 1-.53.541l-6.912.08a.53.53 0 0 1-.535-.529M8.048 20.303a.54.54 0 0 1 .53-.54l6.912-.08a.53.53 0 0 1 .535.528.54.54 0 0 1-.53.541l-6.912.08a.53.53 0 0 1-.535-.529M12.976 12.65a.54.54 0 0 1 .53-.54l6.912-.08a.53.53 0 0 1 .535.528.54.54 0 0 1-.53.54l-6.911.08a.53.53 0 0 1-.536-.528"
					/>
					<path
						fillRule="nonzero"
						d="M16.856 4.92a.54.54 0 0 0-.733.19l-3.525 5.945a.53.53 0 0 0 .19.728.54.54 0 0 0 .733-.189l3.525-5.946a.53.53 0 0 0-.19-.727M12.574 13.425a.54.54 0 0 1 .733.188l3.525 5.946a.53.53 0 0 1-.19.728.54.54 0 0 1-.733-.189l-3.525-5.946a.53.53 0 0 1 .19-.727M11.928 13.425a.54.54 0 0 0-.733.188L7.67 19.56a.53.53 0 0 0 .19.728.54.54 0 0 0 .733-.189l3.525-5.946a.53.53 0 0 0-.19-.727"
					/>
					<path d="M2.57 12.619c-.001.447.27.85.687 1.022s.897.077 1.216-.24a1.1 1.1 0 0 0 .242-1.205 1.115 1.115 0 0 0-1.03-.683c-.616 0-1.115.495-1.116 1.106M19.71 12.619c0 .447.272.85.688 1.022.417.172.897.077 1.216-.24a1.1 1.1 0 0 0 .242-1.205 1.115 1.115 0 0 0-1.03-.683c-.616 0-1.115.495-1.115 1.106M6.855 20.272c0 .448.27.851.687 1.023s.897.077 1.216-.24A1.1 1.1 0 0 0 9 19.85a1.115 1.115 0 0 0-1.03-.683c-.616 0-1.114.495-1.115 1.105M15.425 5.39c0 .448.271.851.688 1.023s.896.077 1.215-.24a1.1 1.1 0 0 0 .243-1.205 1.115 1.115 0 0 0-1.03-.684c-.616.001-1.115.496-1.116 1.106M15.425 20.272c0 .448.271.851.688 1.023s.896.077 1.215-.24a1.1 1.1 0 0 0 .243-1.205 1.115 1.115 0 0 0-1.03-.683c-.616 0-1.115.495-1.116 1.105" />
				</g>
				<g fill="#FFF">
					<path d="M12.078 11.985c.001.41-.497.615-.789.326a.459.459 0 0 1 .327-.784c.255 0 .462.205.462.458m-2.22 0c0 .706.428 1.342 1.084 1.612s1.414.122 1.917-.377c.503-.498.653-1.25.381-1.9a1.76 1.76 0 0 0-1.624-1.078c-.97.002-1.756.781-1.758 1.743M6.216 4.757c0 .448.27.851.687 1.023s.897.077 1.216-.24a1.1 1.1 0 0 0 .242-1.205 1.115 1.115 0 0 0-1.03-.683c-.616 0-1.114.495-1.115 1.105" />
					<path
						fillRule="nonzero"
						d="M7.007 4.288a.54.54 0 0 1 .733.189l3.525 5.945a.53.53 0 0 1-.19.728.54.54 0 0 1-.734-.189L6.817 5.016a.53.53 0 0 1 .19-.728"
					/>
					<path
						fillRule="nonzero"
						d="M7.138 4.88a.54.54 0 0 1 .204.73l-3.387 6.025a.53.53 0 0 1-.725.199.54.54 0 0 1-.204-.73L6.413 5.08a.53.53 0 0 1 .725-.2M7.138 19.275a.54.54 0 0 0 .204-.73L3.955 12.52a.53.53 0 0 0-.725-.2.54.54 0 0 0-.204.73l3.387 6.026a.53.53 0 0 0 .725.199M16.086 4.88a.54.54 0 0 0-.204.73l3.387 6.025a.53.53 0 0 0 .725.199.54.54 0 0 0 .204-.73L16.81 5.08a.53.53 0 0 0-.725-.2M16.086 19.062a.54.54 0 0 1-.204-.73l3.387-6.025a.53.53 0 0 1 .725-.199.54.54 0 0 1 .204.73l-3.387 6.025a.53.53 0 0 1-.725.2"
					/>
					<path
						fillRule="nonzero"
						d="M2.696 12.017a.54.54 0 0 1 .53-.54l6.911-.08a.53.53 0 0 1 .535.528.54.54 0 0 1-.53.54l-6.911.08a.53.53 0 0 1-.535-.528M7.41 4.789a.54.54 0 0 1 .53-.541l6.91-.08a.53.53 0 0 1 .536.528.54.54 0 0 1-.53.541l-6.912.08a.53.53 0 0 1-.535-.528M7.41 19.67a.54.54 0 0 1 .53-.54l6.91-.08a.53.53 0 0 1 .536.529.54.54 0 0 1-.53.54l-6.912.08a.53.53 0 0 1-.535-.528M12.337 12.017a.54.54 0 0 1 .53-.54l6.912-.08a.53.53 0 0 1 .535.528.54.54 0 0 1-.53.54l-6.911.08a.53.53 0 0 1-.536-.528"
					/>
					<path
						fillRule="nonzero"
						d="M16.217 4.288a.54.54 0 0 0-.733.189l-3.525 5.945a.53.53 0 0 0 .19.728.54.54 0 0 0 .733-.189l3.525-5.945a.53.53 0 0 0-.19-.728M11.935 12.792a.54.54 0 0 1 .733.189l3.525 5.945a.53.53 0 0 1-.19.728.54.54 0 0 1-.733-.189l-3.525-5.945a.53.53 0 0 1 .19-.728M11.289 12.792a.54.54 0 0 0-.733.189L7.03 18.926a.53.53 0 0 0 .19.728.54.54 0 0 0 .733-.189l3.525-5.945a.53.53 0 0 0-.19-.728"
					/>
					<path d="M1.93 11.986c0 .447.271.851.688 1.022s.897.077 1.216-.239a1.1 1.1 0 0 0 .242-1.206 1.115 1.115 0 0 0-1.03-.683c-.616.001-1.115.495-1.116 1.106M19.072 11.986c0 .447.27.851.687 1.022s.897.077 1.216-.239a1.1 1.1 0 0 0 .242-1.206 1.115 1.115 0 0 0-1.03-.683c-.616.001-1.115.495-1.115 1.106M6.216 19.64c0 .447.27.85.687 1.022.417.171.897.077 1.216-.24a1.1 1.1 0 0 0 .242-1.205 1.115 1.115 0 0 0-1.03-.683c-.616 0-1.114.495-1.115 1.105M14.786 4.757c0 .448.271.851.688 1.023s.896.077 1.215-.24a1.1 1.1 0 0 0 .243-1.205 1.115 1.115 0 0 0-1.03-.683c-.616 0-1.115.495-1.116 1.105M14.786 19.64c0 .447.271.85.688 1.022.416.171.896.077 1.215-.24a1.1 1.1 0 0 0 .243-1.205 1.115 1.115 0 0 0-1.03-.683c-.616 0-1.115.495-1.116 1.105" />
				</g>
			</g>
		</svg>
	);
}
